import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface StaffAcademicEvent {
  eventName: string;
  startDate: string;
  endDate: string;
  colorCode: string;
  description: string;
}

export interface GetStaffEventInfoResponse {
  status: boolean;
  message?: string;
  body?: {
    eventList: StaffAcademicEvent[];
  };
}

@Injectable({ providedIn: 'root' })
export class StaffAcademicCalendarService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getEventInfo(staffId: number | string, startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('lang', 'en');
    return this.http
      .get<GetStaffEventInfoResponse>(this.url + apiConstants.getStaffAcademicCalendarEvents, { params })
      .pipe(map((res) => res));
  }
}
